
    <div id="main-wrapper">
        <div class="site-wrapper-reveal">
            <div class="position-relative w-100">
                <div class="d-flex align-items-center w-100">
    
                    <img src="../../../assets/images/banners/newmobile-servicebanner.png"
                        class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="Mobile Service Banner" />
    
                    <img src="../../../assets/images/banners/mobilebanner.png"
                        class="img img-responsive d-block d-md-none" width="100%" alt="Mobile Application Banner" />
                    <div class="position-absolute w-100 home-banner">
                        <div class="row h-100 w-100">
                            <div class="col-8 col-md-4 col-sm-6 banner-section">
                                <div class="align-items-center banner-content-title global_title global_banner_title title_banner_content" role="heading" aria-level="1">
                                    <span>Mobile Application Services</span>
                                </div>     
                                 <div class="global_sub_title global_banner_subtitle mt-3" role="heading" aria-level="1">
                                    <span>Native, cross-platform, hybrid, or PWA — we implement your mobile ideas
                                        effectively!</span>
                                </div>
                                <div class="col pt-lg-3 pt-3 mt-lg-3">
                                <a href="contact" class="global_button   text-left col  text-white white_button"  role="button" aria-label="View Contact Page" tabindex="0">
                                <div class="dub-arrow"><img src="../../../assets/images/button/arrowWhite.png" alt="Contact to Explore" /></div>
                                EXPLORE  </a>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class=" banner-subsection col">
             <h5>Trusted by Global Technology companies</h5>
             </div> -->
        </div>
    </div>
    
    <div class="laptop_bg_image mt-5">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <div class="mobile_content_service global_section_header">
    
                        Providing competitive differentiation that keeps you ahead of the industry trends
                    </div>
                    <div class="mobile_service-subcontent global_section_content pt-5">
    
                        <p>A mobile application helps businesses to directly communicate with its customers and find
                            multiple growth opportunities.
                            It acts as a marketing tool to increase client base, brand popularity, and sales.
                            We provide end-to-end mobile application development and services for user-facing and corporate
                            environments.Our team at <span>Maganti IT Resources</span> understands your needs, requirements,
                            and capabilities and
                            develops
                            customized mobile applications. </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="gradation-process-area section-space--ptb_100 my-5">
        <div class="row">
            <div class="col-lg-1 col-sm-12"></div>
            <div class="col-lg-10 col-sm-12">
                <div class="gradation-title-wrapper section-space--mb_60">
                    <div class="gradation-title-wrap ">
                        <div class="heading  global_section_header fourthheading">End-to-End Application Services</div>
                    </div>
                    <div class="gradation-sub-heading">
                        <!-- <h3 class="heading"><mark>01</mark></h3> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1 col-sm-12"></div>
            <div class="col-lg-10 col-sm-12">
                <div class="ht-gradation style-01">
                    <!-- Single item gradation Start -->
                    <div class="item item-1 animate  wow fadeInRight"  data-aos="fade-left" style="visibility: visible;animation-name: fadeInRight;">
                        <div class="line"></div>
                        <div class="circle-wrap">
                            <div class="mask">
                                <div class="wave-pulse wave-pulse-1"></div>
                                <div class="wave-pulse wave-pulse-2"></div>
                                <div class="wave-pulse wave-pulse-3"></div>
                            </div>
                            <div class="fourthheading circle"> <i class="fa-brands fa-android active" aria-hidden="true"></i></div>
                        </div>
                        <div class="content-wrap">
                            <a  role="button"><div class="heading sixthheading " (click)="scrollToSection('androidappdev')"> Android app</div></a>
                            <div class="text global_section_content app ">Time-tested android app development services that deliver easy-to-use, intuitive apps.</div>
                            <a class="gradation-btn gradation-btn1"  (click)="scrollToSection('androidappdev')" role="button">
                                <span class="service-button-text" data-text="Look more">
                                    Look more </span>
                                    <span ><i role="presentation" class="button-icon fas fa-long-arrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                    <!-- Single item gradation End -->
    
                    <!-- Single item gradation Start -->
                    <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left" style="visibility: visible;animation-name: fadeInRight;">
                        <div class="line"></div>
                        <div class="circle-wrap">
                            <div class="mask">
                                <div class="wave-pulse wave-pulse-1"></div>
                                <div class="wave-pulse wave-pulse-2"></div>
                                <div class="wave-pulse wave-pulse-3"></div>
                            </div>
                            <div class="fourthheading circle"> <i role="presentation" class="fa-brands fa-apple"></i></div>
                        </div>
                        <div class="content-wrap">
                            <a  (click)="scrollToSection('iosappdev')"><div class="heading sixthheading " role="button" aria-haspopup="true" tabindex="0">IoS app</div></a>
                            <div class="text global_section_content app ">End-to-end IoS right from strategy, consulting, ideation, design to QA and optimization.</div>
                            <a class="gradation-btn gradation-btn2" (click)="scrollToSection('iosappdev')" role="button">
                                <span class="service-button-text" data-text="Look more">
                                    Look more </span>
                                    <span ><i role="presentation" class="button-icon fas fa-long-arrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                    <!-- Single item gradation End -->
    
                    <!-- Single item gradation Start -->
                    <div class="item item-1 animate  wow fadeInRight" data-aos="fade-left" style="visibility: visible;animation-name: fadeInRight;">
                        <div class="line"></div>
                        <div class="circle-wrap">
                            <div class="mask">
                                <div class="wave-pulse wave-pulse-1"></div>
                                <div class="wave-pulse wave-pulse-2"></div>
                                <div class="wave-pulse wave-pulse-3"></div>
                            </div>
                            <div class="fourthheading circle"> <i role="presentation" class=" fa fa-mobile"></i></div>
                        </div>
                        <div class="content-wrap">
                        <a (click)="scrollToSection('arappdev')" role="button"><div class="heading sixthheading " role="button" aria-haspopup="true" tabindex="0">AR app</div></a>
                            <div class="text global_section_content app">Cutting-edge AR application development services that gives the apps the edge they need to succeed</div>
                            <a class="gradation-btn gradation-btn3" (click)="scrollToSection('arappdev')" role="button">
                                <span class="service-button-text" data-text="Look more">
                                    Look more </span>
                                    <span ><i role="presentation" class="button-icon fas fa-long-arrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                    <!-- Single item gradation End -->
    
                    <!-- Single item gradation Start -->
                    <div class="item item-1 animate wow fadeInRight" data-aos="fade-left" style="visibility: visible;animation-name: fadeInRight;" >
                        <div class="line"></div>
                        <div class="circle-wrap">
                            <div class="mask">
                                <div class="wave-pulse wave-pulse-1"></div>
                                <div class="wave-pulse wave-pulse-2"></div>
                                <div class="wave-pulse wave-pulse-3"></div>
                            </div>
                            <p class="h4 circle"><i role="presentation" class="fa fa-desktop"></i></p>
                        </div>
                        <div class="content-wrap">
                        <a (click)="scrollToSection('crossappdev')" role="button"><div class="heading sixthheading " role="button" aria-haspopup="true" tabindex="0"> Cross platform</div></a>
                            <div class="text global_section_content app">High-performance, custom cross-platform apps that provide compelling user experiences.</div>
                            <a class="gradation-btn gradation-btn4" (click)="scrollToSection('crossappdev')" role="button">
                                <span class="service-button-text" data-text="Look more">
                                    Look more </span>
                                <span ><i role="presentation" class="button-icon fas fa-long-arrow-right"></i></span>
                            </a>
                        </div>
                    </div>
                    <!-- Single item gradation End -->
                </div>
            </div>
        </div>
    </div>
    
    
    <!-- Android app development starts -->
    <div class="mt-5">
        <div id="androidappdev" class="container-fluid ">
            <div class="row">
                <div class="col-sm-12 col-md-12">
                    <div class="mobile_android_content global_section_header mb-md-5">
                    Android Development Services.
                    </div>
                </div>
            </div>
            <div class=" row">
                <div class="col-md-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="offset-sm-1 col-sm-11">
                            <div class="mobile_androidsub-content global_section_content application_subcontent">
                              
                                <p>Our full-cycle custom Android app development process has enabled us to delve deeply into the Android world. We have explored all possible solutions - Smartphones, Android tablets, and Android TV.</p>
                                <p> We use time-tested android app development software as our primary tech stack to deliver easy-to-use, intuitive apps. Our highly skilled Android app developers understand the secret formula for creating apps that have over a million downloads on the Google Play Store.
                                </p>
                            </div>
    
                            <ul class=" global_section_content application_list pt-3">
                                <li> Custom Android Development </li>
                                <li>Android UI/UX Designing </li>
                                <li>Android Web-Based Apps </li>
                                <li>App Testing </li>
                                <li>App Consultation </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-sm-11">
                            <div class="mobile_android-image">
                                <img class="img img-responsive w-100"
                                    src="../../../assets/images/mobile/android-image.png"
                                    alt="android-image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Android app development ends -->
    
    <!-- ios app development starts -->
    <hr>
    <div class="ios mt-2">
        <div class="container-fluid" id="iosappdev">
            <div class="row">
                <div class="col-sm-12 col-md-12">
                    <div class="mobile_android_content global_section_header mb-md-5">
                    IoS App Development Services
                    </div>
                </div>
            </div>
    
            <div class="row ">
                <div class="col-md-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="offset-sm-1 col-sm-11">
                            <div class="mobile_ios_images">
                                <img class="img img-responsive w-100"
                                    src="../../../assets/images/mobile/ios-image.png"
                                    alt="ios-image" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-sm-11">
                            <div class="mobile_ios-subcontent global_section_content">
                                <p class="">We develop the latest iPhone app, applications for smart iOS devices, or Apple wearables based on the latest Apple standards, requirements, and iOS features.</p>
                                <p> Partner with us and be assured that your product is built on the best technology stack available, ensuring consistency, data security, and excellent app performance. We execute the entire process right from strategy, consulting, ideation, design to QA and optimization.
                                </p>
                            </div>
                            <ul class="global_section_content application_list application_list4 p-3">
                                <li> Custom iPhone & iPad App Development </li>
                                <li>Native iPhone & iPad App Development </li>
                                <li>iPhone & iPad App UI/UX Designing </li>
                                <li>Hybrid iPhone App Development </li>
                                <li>iPad App Testing/ Portability </li>
                                <li> iPad Migration </li>
                                <li>Enterprise iPad app development </li>
                                <li>iPad Support & Maintenance </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ios app development ends -->
    
    <!-- AR app development starts -->
     <hr>
    <div class="mt-2">
        <div class="container-fluid" id="arappdev">
            <div class="row">
                <div class="col-sm-12 col-md-12">
                    <div class="mobile_android_content global_section_header mb-md-5">
                    AR App Development Services
                    </div>
                </div>
            </div>
            <div class="row p-5">
                <div class="col-md-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="offset-sm-1 col-sm-11">
                            <div class="mobile_websub-content global_section_content">
                                <p class="pt-3">We at Maganti IT provide cutting-edge and successful augmented reality application development services, giving your augmented apps the edge they need to succeed. We provide unique chances for brands and advertisements to contact and engage with customers while connecting the physical and digital worlds.</p>
                                <p> We have experience creating AR applications for a variety of platforms, including Android, iOS, and Windows. The AR specialists bring your concept to life empowering you with benefits such as marketing advantage, enhanced Customer engagement, and unique brand experiences.</p>
                            </div>
                            <ul class="global_section_content application_list  application_list6 p-3">
                                <li>Benefits Of Investing In AR Development </li>
                                <li>The Marketing Advantage </li>
                                <li>Enhanced Customer Engagement </li>
                                <li>Localization Benefits </li>
                                <li>Industrial Training And Maintenance </li>
                                <li>Location based tracking </li>
                                <li>3D modelling and visualization </li>
                                <li>360 degree panoramic imaging </li>
                                <li>Object recognition </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-sm-12 col-lg-6">
                    <div class="row">
                        <div class="col-sm-11">
                            <div class="mobile_web-image">
                                <img class="img img-responsive w-100"
                                    src="../../../assets/images/mobile/Ar-image.png"
                                    alt="Ar-image" />
    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- AR app development ends -->
    <!-- Cross Platform app development starts -->
     <hr>
    <div class="container-fluid" id="crossappdev">
        <div class=" cross row">
            <div class="col-sm-12 col-md-12 ">
                <div class="mobile_android_content global_section_header mb-md-5">
                    Cross platform app development
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-lg-6  col-sm-12">
                <div class="row">
                    <div class="offset-sm-1 col-sm-11">
                        <div class="mobile_cross_image">
                            <img class="img img-responsive w-100"
                                src="../../../assets/images/mobile/cross-image.png" alt="cross platform" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12  col-lg-6 col-sm-12">
                <div class="row">
                    <div class=" offset-sm-1 col-sm-11">
                        <div class="mobile_websub-content global_section_content">
                            <p class="mt-5">We are a recognized industry leader who creates high-performance, custom cross-platform apps that provide compelling user experiences. Our experts have extensive experience developing such apps using frameworks such as Xamarin, Sencha, IBM MobileFirst, Kony, React Native, and Titanium.</p>
                            <p>Along with helping achieve operational excellence across all of your mobile channels by collaborating, we help improve user engagement, reduce turnaround time, and drive massive cost savings.
                            </p>
                        </div>
                        <ul class="global_section_content application_list  application_list5">
                            <li>React Native app development </li>
                            <li>React Native app development </li>
                            <li>Xamarin app development </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!--======= Insights section Start =======-->
    <div class="layouts-section-wrap">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 offset-sm-2 col-sm-8">
                    <div class="pt-md-5" data-aos="fade-up">
                        <div class="insight-title global_section_header" role="heading"  aria-level="1">
                            Insights
                            <!-- <a href=""></a> -->
                        </div>
                        <div class="insight-subtitle  vision-content-section mt-3">
                            <span>
                                Explore insights and inspiration to unlock innovation, build trust, and engineer advantage
                                for your digital journey.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="container-fluid">
            <div class="row">
                <main class="col-8 px-0">
    
                  
                    <swiper-container appSwiper #swiper [config]="swiperConfig" thumbs-swiper=".mySwiper2"
                        (slidechange)="slideChange($event)">
                        <swiper-slide *ngFor="let item of Card">
                            <div class="ratio ratio-4x3"
                                [ngStyle]="{background: 'url(' + item.url +') no-repeat top center / contain'}"></div>
                        </swiper-slide>
                    </swiper-container>
    
    
                </main>
    
              
                <aside class="col-4 p-4">
    
                    <h3 [textContent]="Card[index].title"></h3>
                    <p [textContent]="Card[index].description"></p>
    
                </aside>
           
    
            </div>
        </div> -->
        <div class="container-fluid">
    
            <div class="-row d-lg-none pt-lg-4">
                <div class="px-4 -col-lg-12">
                    <div class="flexible-image-slider-wrap">
    
                        <swiper-container 
                        class="single-flexible__container " 
                        slides-per-view="1" 
                        autoplay="true" 
                        loop="true" 
                        navigation="true" 
                        pagination="true">
                      
                        <swiper-slide>
                          <!-- Single flexible slider Start -->
                          <div class="single-flexible-slider">
                            <img src="../../../assets/images/homepage/insights/slider1.png" class="img img-responsive w-100 h-100" alt="firstslider" />
                            <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                              <div class="insight-content global_section_header px-0" role="heading" aria-level="1">
                                <span role="heading" aria-level="1">The Future of Marketing Personalization: AI-Powered Journeys</span>
                              </div>
                              <div class="insight-subcontent global_section_content px-0 pt-lg-1">
                                <div>Across the entire customer journey, AI is assisting marketers in providing more helpful, enjoyable experiences for shoppers and improving performance. Find how retail stores can capitalize on this technology trend.</div>
                              </div>
                              <div class="insight-button text-center py-3 py-md-5">
                                <a href="personalize-and-machine-learning" class="global_button" role="button" aria-label="Read Personalize ML" tabindex="0">
                                  <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="Read All Insights of Marketing Personalization" /></div>READ ALL INSIGHTS
                                </a>
                              </div>
                            </div>
                          </div>
                          <!-- Single flexible slider End -->
                        </swiper-slide>
                      
                        <swiper-slide>
                          <!-- Single flexible slider Start -->
                          <div class="single-flexible-slider">
                            <img src="../../../assets/images/homepage/insights/slider2.png" class="img img-responsive w-100 h-100" alt="secondslider" />
                            <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                              <div class="insight-content global_section_header px-0">
                                <span>Embracing the next era of Digital: From Survival, Thriving to Reinvigorating</span>
                              </div>
                              <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                                <div>Learn how businesses have progressed into the digital post-pandemic era and how far they can go to adapt to the changing customer mindset.</div>
                              </div>
                              <div class="insight-button text-center py-3 py-md-5">
                                <a href="/postpandamic" class="global_button"  role="button" aria-label="Read Postpandamic Insights" tabindex="0">
                                  <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="Read All Insights to Thrive" /></div>READ ALL INSIGHTS
                                </a>
                              </div>
                            </div>
                          </div>
                          <!-- Single flexible slider End -->
                        </swiper-slide>
                      
                        <swiper-slide>
                          <!-- Single flexible slider Start -->
                          <div class="single-flexible-slider">
                            <img src="../../../assets/images/homepage/insights/slider3.png" class="img img-responsive w-100 h-100" alt="thirdslider" />
                            <div class="px-5 w-100 col-12-order-2-col-lg-6-order-lg-1">
                              <div class="insight-content global_section_header px-0">
                                <span>Drive digital adoption. Every minute. Every hour. Every day</span>
                              </div>
                              <div class="insight-subcontent global_section_content px-0 pt-lg-5">
                                <div>Increase software adoption and knowledge retention while making a positive impact on the working lives of your employees.</div>
                              </div>
                              <div class="insight-button text-center py-3 py-md-5">
                                <a href="migrate-cloud" class="global_button" role="button" aria-label="Read migrate cloud Insights" tabindex="0">
                                  <div class="dub-arrow"><img src="../../../assets/images/button/arrowBlack.png" alt="Read All Insights of cloud Migration" /></div>READ ALL INSIGHTS
                                </a>
                              </div>
                            </div>
                          </div>
                          <!-- Single flexible slider End -->
                        </swiper-slide>
                      
                        <!-- Remove custom navigation buttons as Swiper handles this automatically -->
                      </swiper-container>
                      
                    </div>
                </div>
            </div>
    
            <!-- <div class="row d-none d-lg-block" id="InsightsSlider">
            </div> -->
            <div class="" >
                <app-insightsslider></app-insightsslider>
              </div>
    
        </div>
    </div>
    <!--======= Insights section End =======-->
   